import { Box, Button, Grid, Stack, Typography, ValidationErrors } from "@compass/core";
import SignatureCanvas from "react-signature-canvas";

export type SignUpSignatureProps = {
  label: string;
  signature: any;
  setSignature: (signature: any) => void;
  // handleChange: (signature: any) => any;
  validationErrors: ValidationErrors;
};

export const SignUpSignature = ({ label, signature, setSignature, validationErrors }: SignUpSignatureProps) => {
  // const [signature, setSignature] = useState<any>({});

  // useEffect(() => {
  //   var signatureData = signature.getTrimmedCanvas().toDataURL("image/png");
  //   handleChange(signatureData);
  // }, [signature]);

  return (
    <Stack direction="column">
      <Stack direction="row" py={2}>
        <Typography variant="h5">{label}</Typography>
        <Typography color="error">*</Typography>
      </Stack>
      {validationErrors?.[`signatureData`] && (
        <Grid item xs={12}>
          <Typography color="error">{validationErrors?.[`signatureData`]?.[0]}</Typography>
        </Grid>
      )}
      <Grid container spacing="sm">
        <Grid item xs={12}>
          <Box sx={{ width: 350, height: 200, backgroundColor: "white" }}>
            <SignatureCanvas
              penColor="black"
              ref={(ref) => setSignature(ref)}
              canvasProps={{ width: 350, height: 200 }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={() => signature.clear()}>
            Clear
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};
